import { Tokens } from '@grupoboticario/flora'
import { useIsMobile, useMediaQuery } from '@grupoboticario/flora-react'
import { useEffect, useState } from 'react'

export const useSlidesToShow = () => {
  const [slidesToShow, setSlidesToShow] = useState(4)
  const isMobile = useIsMobile()
  const isDesktop = useMediaQuery(Tokens.media.tablet)
  const isUltrawide = useMediaQuery(Tokens.media.ultrawide)

  useEffect(() => {
    if (isMobile) {
      setSlidesToShow(2)
      return
    }
    if (isUltrawide) {
      setSlidesToShow(6)
      return
    }
    if (isDesktop) {
      setSlidesToShow(5)
      return
    }

    setSlidesToShow(4)
  }, [isMobile, isDesktop, isUltrawide])

  return slidesToShow
}
